import React from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup, Button, ButtonProps } from '@mui/material';

/**
 * A controlled form component used with react-hook-form.
 * @param control the form control created by react-hook-form (useForm)
 * @param value the value related to this controlled form input
 * @param defaultValue the default value related to this controlled form input
 * @param data the array containing the data that is used to render the chip "buttons"
 * @param onSelectElement function called when one of the chips is selected
 * @param row boolean attribute to determine if buttons are arranged in a row
 */

interface ControlledChipGroupProps {
  control: any;
  value: string;
  name: string;
  defaultValue?: string;
  data: any;
  resetError: any;
  resetValues?: any;
  row?: boolean;
  sx?: ButtonProps['sx'];
  size?: ButtonProps['size'];
}

function ControlledChipGroup({
  control,
  value,
  name,
  defaultValue,
  size = 'small',
  data,
  resetError,
  resetValues,
  row,
  sx,
}: ControlledChipGroupProps) {
  return (
    <Controller
      defaultValue={defaultValue || ''}
      name={name}
      control={control}
      render={({ field: { onChange } }: any) => (
        <RadioGroup value={value} name={name} row={row} sx={sx}>
          {data?.map((element: any) => {
            const selected = element.key === value;

            return (
              <Button
                color="primary"
                key={element.key}
                variant={selected ? 'contained' : 'outlined'}
                size={size}
                disableElevation
                sx={{ textTransform: 'none' }}
                onClick={() => {
                  resetError();
                  if (resetValues) {
                    resetValues();
                  }
                  onChange(element.key);
                }}
                style={{ margin: 6 }}
              >
                {element.label}
              </Button>
            );
          })}
        </RadioGroup>
      )}
    />
  );
}

export default ControlledChipGroup;
